import { Component, OnInit ,Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'app-practice-set-access-dialog',
  templateUrl: './practice-set-access-dialog.component.html',
  styleUrls: ['./practice-set-access-dialog.component.scss']
})
export class PracticeSetAccessDialogComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data: { message: string }  ,private dialogRef: MatDialogRef<PracticeSetAccessDialogComponent>) { }

  ngOnInit() {
  }

  closeDialog(){
    this.dialogRef.close();
  }

}
